import { classNames } from "@frec-js/common-web";
import { FC } from "react";

import { PostType } from "../utils/blogApi";

export const BlogMetaCategory: FC<{ post: PostType; className?: string }> = ({
  post,
  className,
}) => {
  return post.categories.length > 0 ? (
    <div className={classNames("flex items-center gap-2", className)}>
      {post.categories.join(", ")}
    </div>
  ) : null;
};
